<template>
    <v-container fluid pa-0 v-if="!$store.getters.progress" style="padding-bottom: 10% !important">
        <v-layout row wrap>
            <v-flex xs12>
                <v-card class="flex pa-0">
                    <v-toolbar flat color="grey lighten-4">
                        <v-toolbar-title class="grey--text text--darken-4">Dettaglio Cliente</v-toolbar-title>
                        <v-spacer></v-spacer>
                        <v-tooltip top>
                            <v-btn @click="$eventBusUtility.goTo($router, 'customers-edit', model.id)" slot="activator" icon>
                                <v-icon color="primary">mode_edit</v-icon>
                            </v-btn>
                            <span>Modifica Cliente</span>
                        </v-tooltip>                                   
                    </v-toolbar>
                    <v-divider></v-divider>
                    <v-container fluid pa-0 px-2>
                        <v-layout row :wrap="$vuetify.breakpoint.smAndDown">
                            <v-flex xs12 sm12 md6 lg6>
                                <v-list two-line class="w100p">
                                <v-subheader>Cliente</v-subheader>
                                    <v-list-tile>
                                        <v-list-tile-action>
                                            <v-icon color="primary">person</v-icon>
                                        </v-list-tile-action>
                                        <v-list-tile-content>
                                            <v-list-tile-title>Nome</v-list-tile-title>
                                            <v-list-tile-sub-title>{{ model.name }}</v-list-tile-sub-title>
                                        </v-list-tile-content>
                                    </v-list-tile>                                    
                                    <v-list-tile>
                                        <v-list-tile-action>
                                            <v-icon color="primary">phone</v-icon>
                                        </v-list-tile-action>
                                        <v-list-tile-content>
                                            <v-list-tile-title>Telefono</v-list-tile-title>
                                            <v-list-tile-sub-title>{{ model.primary_telephone }}</v-list-tile-sub-title>
                                        </v-list-tile-content>
                                    </v-list-tile>                                    
                                    <v-list-tile>
                                        <v-list-tile-action>
                                            <v-icon color="primary">email</v-icon>
                                        </v-list-tile-action>
                                        <v-list-tile-content>
                                            <v-list-tile-title>Email</v-list-tile-title>
                                            <v-list-tile-sub-title>{{ model.primary_email }}</v-list-tile-sub-title>
                                        </v-list-tile-content>
                                    </v-list-tile>
                                    <v-subheader>Scheda Cliente</v-subheader>
                                    <v-list-tile>
                                        <v-list-tile-action>
                                            <v-icon color="primary">face</v-icon>
                                        </v-list-tile-action>
                                        <v-list-tile-content>
                                            <v-list-tile-title>Taglio</v-list-tile-title>
                                            <v-list-tile-sub-title>{{ model.hair_cut }}</v-list-tile-sub-title>
                                        </v-list-tile-content>
                                    </v-list-tile>                                    
                                    <v-list-tile>
                                        <v-list-tile-action>
                                            <v-icon color="primary">face</v-icon>
                                        </v-list-tile-action>
                                        <v-list-tile-content>
                                            <v-list-tile-title>Permanente</v-list-tile-title>
                                            <v-list-tile-sub-title>{{ model.hair_permanent }}</v-list-tile-sub-title>
                                        </v-list-tile-content>
                                    </v-list-tile>
                                    <v-list-tile>
                                        <v-list-tile-action>
                                            <v-icon color="primary">face</v-icon>
                                        </v-list-tile-action>
                                        <v-list-tile-content>
                                            <v-list-tile-title>Colpi di luce</v-list-tile-title>
                                            <v-list-tile-sub-title>{{ model.hair_light_strokes }}</v-list-tile-sub-title>
                                        </v-list-tile-content>
                                    </v-list-tile>
                                </v-list>
                            </v-flex>

                            <v-divider vertical class="hidden-sm-and-down"></v-divider>

                            <v-flex xs12 sm12 md6 lg6>
                                <v-list two-line class="w100p">
                                <v-subheader></v-subheader>
                                    <v-list-tile>
                                        <v-list-tile-action>
                                            <v-icon color="primary">cake</v-icon>
                                        </v-list-tile-action>
                                        <v-list-tile-content>
                                            <v-list-tile-title>Compleanno</v-list-tile-title>
                                            <v-list-tile-sub-title>{{ model.birthday }}</v-list-tile-sub-title>
                                        </v-list-tile-content>
                                    </v-list-tile>
                                    <v-list-tile>
                                        <v-list-tile-avatar class="v-avatar-show">
                                            <v-avatar v-if="model.creator_avatar"
                                                class="custom-avatar"
                                                :size="26" 
                                                v-ripple
                                                :style="{'background-image': 'url(' + model.creator_avatar + ')'}">
                                            </v-avatar>
                                            <v-avatar v-else :class="$eventBusUtility.bgColor(model.creator_id)" :size="26">
                                                <span class="white--text fs14" v-if="model.creator">{{ model.creator.charAt(0) }}</span>
                                            </v-avatar>
                                        </v-list-tile-avatar>
                                        <v-list-tile-content>
                                            <v-list-tile-title>Creatore</v-list-tile-title>
                                            <v-list-tile-sub-title>{{ model.creator }}</v-list-tile-sub-title>
                                        </v-list-tile-content>
                                    </v-list-tile>
                                    <v-list-tile>
                                        <v-list-tile-action>
                                        </v-list-tile-action>
                                        <v-list-tile-content>
                                            <v-list-tile-title>Creato il</v-list-tile-title>
                                            <v-list-tile-sub-title>{{ model.created_at }}</v-list-tile-sub-title>
                                        </v-list-tile-content>
                                    </v-list-tile>
                                    <v-subheader></v-subheader>
                                    <v-list-tile>
                                        <v-list-tile-action>
                                            <v-icon color="primary">face</v-icon>
                                        </v-list-tile-action>
                                        <v-list-tile-content>
                                            <v-list-tile-title>Colore</v-list-tile-title>
                                            <v-list-tile-sub-title>{{ model.hair_color }}</v-list-tile-sub-title>
                                        </v-list-tile-content>
                                    </v-list-tile> 
                                    <v-list-tile>
                                        <v-list-tile-action>
                                            <v-icon color="primary">face</v-icon>
                                        </v-list-tile-action>
                                        <v-list-tile-content>
                                            <v-list-tile-title>Lavaggio</v-list-tile-title>
                                            <v-list-tile-sub-title>{{ model.hair_wash }}</v-list-tile-sub-title>
                                        </v-list-tile-content>
                                    </v-list-tile>                                                                      
                                    <v-list-tile>
                                        <v-list-tile-action>
                                            <v-icon color="primary">face</v-icon>
                                        </v-list-tile-action>
                                        <v-list-tile-content>
                                            <v-list-tile-title>Meches</v-list-tile-title>
                                            <v-list-tile-sub-title>{{ model.hair_meches }}</v-list-tile-sub-title>
                                        </v-list-tile-content>
                                    </v-list-tile>
                                </v-list>
                            </v-flex>
                        </v-layout>
                        <v-divider v-if="model.description"></v-divider>
                        <v-layout row wrap pt-2 pb-2 v-if="model.description">
                            <template>
                                <v-subheader class="pl-4 pt-3">Descrizione</v-subheader>
                                <v-flex xs12>
                                    <v-card class="flex" elevation="0">
                                        <div class="blockquote pl-4 pr-4 fs14i" v-html="model.description"></div>
                                    </v-card>
                                </v-flex>
                            </template>     
                        </v-layout>
                    </v-container>
                </v-card>
            </v-flex>

            <v-flex xs12 pt-3>
                <crud
                    title='Carte Fedeltà'
                    action-icon='card_membership'
                    model-def='fidelitycards'
                    :sub-filters="subFilters"
                    action-position='absolute'
                    :default-input='{customer_id: id}'
                ></crud>
            </v-flex>

        </v-layout>
    </v-container>
</template>

<script>
export default {
	name: 'customer',
	props: {
		id: Number
	},

	data() {
		return {
			model: {},
			url: 'customers/',
			saved: false,
			subFilters: {
				customer_id: this.id
			}
		}
	},

	created() {
		this.axios.get(this.url + this.id).then(response => {
			// get body data
			this.model = response.data.model
			this.$store.commit('endProgress')
		},
		response => {
			// error callback
		})
	}
}
</script>

<style>
</style>
